import Image from 'next/image';
import BankMisr from 'public/payment/Banque-Misr.jpeg';
import Cib from 'public/payment/cib.jpeg';
import Kiosk from 'public/payment/kiosk.svg';
import Mashriq from 'public/payment/mashreq.jpeg';
import Nbe from 'public/payment/NBE.jpeg';
import Sympl from 'public/payment/sympl.jpeg';
import Valu from 'public/payment/valu.png';
import Aman from 'public/payment/aman.png';
import Waseela from 'public/payment/waseela.png';
import Shoola from 'public/payment/souhoola.png';
import Forsa from 'public/payment/forsa.png';
import Halan from 'public/payment/halan.png';
import PremiumCard from 'public/payment/premium-card.png';
import Wallet from 'public/payment/meeza.png';
import React from 'react';
import { PaymentMethods } from 'types/Checkout';
import { Card, CheckActive, PaymentMethodCardWrapper } from './PaymentMethodCard.styled';

type Props = {
  paymentMethod:
    | PaymentMethods['instalment_payment'][number]
    | PaymentMethods['other_payment'][number]
    | PaymentMethods['E_WALLET'][number];
  onClick: (paymentMethodKey: string) => Promise<void>;
  isSelected: boolean;
  isDisabled: boolean;
};

export default function PaymentMethodCard({ paymentMethod, isSelected, isDisabled, onClick }: Props) {
  const imgSrc =
    paymentMethod === 'BANK_MISR_INSTALMENT'
      ? BankMisr
      : paymentMethod === 'CIB_INSTALMENT'
      ? Cib
      : paymentMethod === 'MASHREQ_INSTALMENT'
      ? Mashriq
      : paymentMethod === 'NBE_INSTALMENT'
      ? Nbe
      : paymentMethod === 'VALU_INSTALMENT'
      ? Valu
      : paymentMethod === 'SYMBL_INSTALMENT'
      ? Sympl
      : paymentMethod === 'AMAN_INSTALLMENT'
      ? Aman
      : paymentMethod === 'WASEELA_INSTALLMENT'
      ? Waseela
      : paymentMethod === 'SHOOLA_INSTALLMENT'
      ? Shoola
      : paymentMethod === 'FORSA_INSTALLMENT'
      ? Forsa
      : paymentMethod === 'PREMIUM_CARD_INSTALLMENT'
      ? PremiumCard
      : paymentMethod === 'HALAN_INSTALLMENT'
      ? Halan
      : paymentMethod === 'MEEZA_WALLET'
      ? Wallet
      : paymentMethod === 'WALLET'
      ? Wallet
      : Kiosk;
  return (
    <PaymentMethodCardWrapper
      htmlFor={paymentMethod + '_METHOD'}
      onClick={() => !isSelected && onClick(paymentMethod)}
      isDisabled={isDisabled}
    >
      <input type="radio" name={'PAYMENT_METHOD'} id={paymentMethod + '_METHOD'} checked={isSelected} />
      <CheckActive />
      <Card>
        <Image src={imgSrc} alt={'Payment Method'} layout="fill" objectFit="contain" />
      </Card>
    </PaymentMethodCardWrapper>
  );
}
